import { Component, OnInit, ViewChild, Renderer2, ViewChildren, QueryList } from '@angular/core';
import { FormGroup, FormControl, FormArray, Validators, FormBuilder, NgForm, AbstractControl } from '@angular/forms';
import { Subject ,  Subscription } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { NgxSpinnerService } from 'ngx-spinner';
import { logbaseService } from '../../services/logbase.service';
import { NgbModal, ModalDismissReasons, NgbModalRef, NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CustomValidators } from '../../directives/custom-validator.directive';
import { ToastrService } from 'ngx-toastr';
import { Router, ActivatedRoute } from '@angular/router';
import { dateFormatPipe } from '../../pipes/dateFormatPipe';
import { TranslateService } from '@ngx-translate/core';
import { AngularCsv } from 'angular-csv-ext/dist/Angular-csv';
import { environment } from '../../../environments/environment';


@Component({
  selector: 'app-supply-process-code',
  templateUrl: './supply-process-code.component.html',
  styleUrls: ['./supply-process-code.component.scss']
})
export class SupplyProcessCodeComponent implements OnInit {
  saas_token=environment.excel_upload_saas;
  ReplenThresh: any;
  shelfCap: any;
  boxPerPal: any;
  thresholdGreater: boolean;
  thresholdValue: any;
  capacityValue: any;
  dataDeliveryPt: void;
  historyGroup: any;
  modifyClicked: boolean;
  historyValue: any;
  groupDropdownList: any;
  supplyCodeStatus: any;
  supplyStatus: string;
  prodOpt: any;
  historyListData: any;
  changeLocationEnable: boolean;
  toBeApproved: any;
  cities:any;
  historyList: any;
  identifierTaken: boolean;
  partIdentifier: any;
  data: any;
  identifierData: any;
  historyData: any;
  locationHistory: any;
  levelAccess: boolean;
  rackAccess: boolean;
  lineNumbers: any;
  showLocationHistory: boolean;
  changeButton: boolean;
  saveButton: boolean;
  displayTables: boolean;
  processListTriggered: boolean;
  processCodedata: any;
  processCodeList: any;
  roleName: any;
  userSuppCode: any;
  loginId: any;
  userRoleID: any;
  delPoint: any;
  delPlant: any;
  partDataDetails: any;
  partData: any;
  processCodeForm: FormGroup;
  listTriggered: boolean;
  deliveryPoint: any;
  plantName: any;
  partList: any;
  partDetails: any;
  @ViewChildren(DataTableDirective)
  dtElements: QueryList<DataTableDirective>;
  datatableElement: DataTableDirective;
  dtOptions: DataTables.Settings[] = [];
  partList_dtTrigger: Subject<any> = new Subject();
  processList_dtTrigger: Subject<any> = new Subject();
  history_dtTrigger: Subject<any> = new Subject();
  part: any;
  modalRef: NgbModalRef;
  newIdentifier: any;
  sub: Subscription;
  dropdownList = [];
    selectedItems = [];
    dropdownSettings = {};
  buildingNumberOpt: any[] = [{ value: 106, name: "#106=第８機械工場" }, { value: 107, name: "#107=第９機械工場" }, { value: 110, name: "#110=第２機械工場" }, { value: 111, name: "#111=第１組立工場" }, { value: 113, name: "#131=第５機械工場" },
  { value: 139, name: "#139=EOL工場" }, { value: 141, name: "#141=第1シャシ組立工場" }, { value: 142, name: "#142=第2シャシ組立工場" }, { value: 143, name: "#143=第3シャシ組立工場" }, { value: 144, name: "#144=第2EOL工場" },
  { value: 310, name: "#310=ＫＤ倉庫" }, { value: 312, name: "#312=第２倉庫" }, { value: 324, name: "#324=南門ＫＤ倉庫" }, { value: 6, name: "#6=第1倉庫" }, { value: 327, name: "#327=第7倉庫" }, { value: 102, name: "#102=第4機械工場" }, { value: 108, name: "#108=第3倉庫" }, { value: 109, name: "#109=第1機械工場" }];
  rackPattern = /^[a-zA-Z0-9]{2}$/
  levelPattern = /^[a-zA-Z0-9]{1}$/
  columnPattern = /^[1-9]$/
  shelfCapPattern = /^\d+$/
  thresholdPattern = /^\d+$/
  productCodepattern = /^[A-Z0-9]{1}$/
  processCodePattern = /^[a-zA-Z0-9]{1}$/
  processNamePattern = /^[a-zA-Z0-9]{2}$/
  partIdentifierPattern = /^[a-zA-Z0-9]{1}$/
  delPlantOpt = ['T', 'B', 'N', 'Z', 'Others'];
  // weekDayPattern = /[^A-Za-z]+/;
  showTiming: boolean = false;
  secondsValue: any;
  minuteValue: any;
  hourValue: any;
  dayOfMonthValue: any;
  monthOfYearValue: any;
  dayOfWeekValue: any;
  dateFormatPipeFilter = new dateFormatPipe();
  suppProcessCodeURL: any;
  transModeOpt = ["Forklift", "Hand Cart", "Tugger"];
  triggerOpt = ["Consumption Base", "Demand Base", "E-Kanban", "Machining", 'Cyclic'];

  lineNumbersettings

  lineCodeList: any[];
  partSrchInput: string='';
  lineNoSrchInput: any[]=[];

  cronExpressionListHead:any[] = ['Field', 'Required', 'Allowed Values', 'Allowed special character']
  cronExpressionListInfo:any[] = [
    {name:'Seconds', mandatory:'YES', allowedValue:'0-59', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:''},
    {name:'Minutes', mandatory:'YES', allowedValue:'0-59', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:''},
    {name:'Hour', mandatory:'YES', allowedValue:'0-23', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:''},
    {name:'Day of Month', mandatory:'YES', allowedValue:'1-31', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:''},
    {name:'Month of Year', mandatory:'YES', allowedValue:'1-12', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:''},
    {name:'Day of Week', mandatory:'YES', allowedValue:'0-6', allowedSepcialCharacter: ['&#42;', '&#44;', '&#45;'], remarks:'0=Sunday-6=Saturday'},
   
]
  constructor(private logbaseService: logbaseService, private modalService: NgbModal, private form: FormBuilder,
    private spinner: NgxSpinnerService, private toaster: ToastrService, private route: ActivatedRoute, private translate: TranslateService) { 
      this.lineNumbersettings = {
        singleSelection: false,
        text: "Select Line Numbers",
        selectAllText: this.translate.instant('Select All'),
        unSelectAllText: "UnSelect All",
        enableSearchFilter: true,
        classes: "custom-class",
        badgeShowLimit: 2,
        limitSelection: 10
      };
    }

  ngOnInit() {
 
    var lineCodeListArr = [];
    let userDetails = localStorage.getItem('userDetails');
    let userDetJson = JSON.parse(userDetails);
    this.userRoleID = userDetJson.userRoleMappings[0].roleId;
    this.roleName = userDetJson.userRoleMappings[0].roleName;
    this.loginId = userDetJson.loginId;
    this.userSuppCode = userDetJson.supplierCode;
    this.lineNumbers = userDetJson.lineNumbers;
 
    this.lineNumbers.forEach(function (value, key) {
      lineCodeListArr.push({ item_id: key + 1, item_text: value });
    });

    this.lineCodeList = lineCodeListArr;
    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 3,
      allowSearchFilter: true
  };
    console.log(this.lineCodeList);

    this.createFormControls();

    this.getSuppProcessCodeURL();
  }

  getSuppProcessCodeURL() {
    this.logbaseService.getSuppProcessCodeURL().subscribe(
      result => {
        this.suppProcessCodeURL = result;
      })
  };

  exportSuppProcessCode() {
    window.open(this.suppProcessCodeURL.response.blobUrl, "_blank");
  };

  searchParts() {
    this.spinner.show();
    this.displayTables = true;
    let lineNos = [];
  
    if (this.lineNoSrchInput && this.lineNoSrchInput.length > 0) {
      this.lineNoSrchInput.forEach(element => {
        lineNos.push(element.item_text);
      });
    }
  
    let data = {
      lineNumbers: lineNos.length > 0 ? lineNos : null,
      partNumber: this.partSrchInput ? this.partSrchInput : null,
      roleId: this.userRoleID
    };
  
    if (!data.partNumber && (!data.lineNumbers || data.lineNumbers.length === 0)) {
      this.spinner.hide();
      return; 
    }
  
    this.logbaseService.searchByPartNumber(data).subscribe(
      result => {
        this.partDetails = result;
        this.partList = this.partDetails.response;
        this.partList.forEach(element => {
          this.dataDeliveryPt = element.deliveryPoint;
        });
        this.spinner.hide();
        if (this.partList.statusMessage != "FAILURE") {
          this.partList.forEach(element => {
            this.deliveryPoint = element.deliveryPoint;
          });
          this.logbaseService.checkDeliveryPoint(this.deliveryPoint).subscribe(
            result => {
              this.plantName = result.response.plantName;
            });
        }
      }
    );
  
    let dataToSend = {
      lineNumbers: lineNos.length > 0 ? lineNos : null,
      partNumber: this.partSrchInput ? this.partSrchInput : null,
      roleId: this.userRoleID
    };
  
    this.logbaseService.searchProcessCode(dataToSend).subscribe(
      result => {
        this.processCodeList = result;
        this.processCodedata = this.processCodeList.response;
        this.spinner.hide();
        if (this.processListTriggered == true) {
          this.processList_dtTrigger.next(true);
        }
        this.processListTriggered = false;
      }
    );
  }
  changeInput(event:any){
    this.partSrchInput=event;
  }

  createFormControls() {
    this.processCodeForm = new FormGroup({
      cardId: new FormControl({ value: '', disabled: true }),
      deliveryPlant: new FormControl({ value: '', disabled: false }, Validators.required),
      partNumber: new FormControl({ value: '', disabled: true }, [Validators.required, Validators.maxLength(16)]),
      lineNumber: new FormControl({ value: '', disabled: true }, Validators.required),
      storeQty: new FormControl({ value: '', disabled: false }, Validators.maxLength(5)),
      transactionCode: new FormControl({ value: '', disabled: true }, Validators.required),
      productionGrp: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(2)]),
      partIdetifier: new FormControl({ value: '', disabled: false }, [Validators.maxLength(1)]),
      lotSeperate: new FormControl({ value: '', disabled: false }, Validators.maxLength(1)),
      updateDate: new FormControl({ value: '', disabled: true }),
      buildingNumber: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
      productCode: new FormControl({ value: '', disabled: false }, Validators.required),
      group: new FormControl({ value: '', disabled: false }, [Validators.required]),
      rackNumber: new FormControl({ value: '', disabled: false }, [Validators.required]),
      validFrom: new FormControl({ value: '', disabled: false }),
      validTo: new FormControl({ value: '', disabled: false }),
      processCde: new FormControl({ value: '', disabled: false }, [Validators.required]),
      processNo: new FormControl({ value: '', disabled: false }, [Validators.required, Validators.maxLength(3)]),
      level: new FormControl({ value: '', disabled: false }, [Validators.required]),
      partName: new FormControl({ value: '', disable: false }, Validators.required),
      column: new FormControl({ value: '', disable: false }),
      shelfCapacity: new FormControl({ value: '', disabled: false }),
      replenishmentThreshold: new FormControl({ value: '', disabled: false }),
      transportationMode: new FormControl({ value: '', disabled: false }),
      trigger: new FormControl({ value: '', disabled: false }),
      boxperpallet: new FormControl({ value: '', disabled: false }),
      seconds: new FormControl({value: '', disabled: false }),
      minute: new FormControl({ value: '', disabled: false }),
      hour: new FormControl({ value: '', disabled: false }),
      dayOfMonth: new FormControl({ value: '', disabled: false }),
      monthOfYear: new FormControl({ value: '', disabled: false }),
      dayOfWeek: new FormControl({ value: '', disabled: false }),

    });
  }
  triggerChange(event) {
    console.log(event.target.value);
    if (event.target.value === 'Cyclic') {
      this.processCodeForm.get('seconds').setValidators(Validators.required);
      this.processCodeForm.get('seconds').updateValueAndValidity();
      this.processCodeForm.get('minute').setValidators(Validators.required);
      this.processCodeForm.get('minute').updateValueAndValidity();
      this.processCodeForm.get('hour').setValidators(Validators.required);
      this.processCodeForm.get('hour').updateValueAndValidity();
      this.processCodeForm.get('dayOfMonth').setValidators(Validators.required);
      this.processCodeForm.get('dayOfMonth').updateValueAndValidity();
      this.processCodeForm.get('monthOfYear').setValidators(Validators.required);
      this.processCodeForm.get('monthOfYear').updateValueAndValidity();
      this.processCodeForm.get('dayOfWeek').setValidators(Validators.required);
      this.processCodeForm.get('dayOfWeek').updateValueAndValidity();
      this.showTiming = true;
    } else {
      this.processCodeForm.get('seconds').setValidators([]);
      this.processCodeForm.get('seconds').updateValueAndValidity();
      this.processCodeForm.get('minute').setValidators([]);
      this.processCodeForm.get('minute').updateValueAndValidity();
      this.processCodeForm.get('hour').setValidators([]);
      this.processCodeForm.get('hour').updateValueAndValidity();
      this.processCodeForm.get('dayOfMonth').setValidators([]);
      this.processCodeForm.get('dayOfMonth').updateValueAndValidity();
      this.processCodeForm.get('monthOfYear').setValidators([]);
      this.processCodeForm.get('monthOfYear').updateValueAndValidity();
      this.processCodeForm.get('dayOfWeek').setValidators([]);
      this.processCodeForm.get('dayOfWeek').updateValueAndValidity();
      this.showTiming = false;
    }
  }
  prodGroupValue(value) {
    if (value == 'T') {
      this.prodOpt = ['26'];
    }
    else if (value == 'B') {
      this.prodOpt = ['33', '34']
    }
    else if (value == 'Z') {
      this.prodOpt = ['26', '33', '34']
    }
    else if (value == 'N') {
      this.prodOpt = ['26', '33', '34']
    }
    else if (value == 'Others') {
      this.prodOpt = ['26', '33', '34']
    }
  }

  checkCapacity(val) {
    this.capacityValue = val;
    if (this.thresholdValue >= this.capacityValue) {
      this.thresholdGreater = true;
    }
    else if (this.thresholdValue <= this.capacityValue) {
      this.thresholdGreater = false;
    }
  }

  checkThreshold(value) {
    this.thresholdValue = value
    if (this.thresholdValue >= this.capacityValue) {
      this.thresholdGreater = true;
    }
    else if (this.thresholdValue <= this.capacityValue) {
      this.thresholdGreater = false;
    }
  }

  checkValue() {
    this.thresholdValue = parseInt(this.ReplenThresh);
    this.capacityValue = parseInt(this.shelfCap);
    if (this.thresholdValue >= this.capacityValue) {
      this.thresholdGreater = true;
    }
    else if (this.thresholdValue <= this.capacityValue) {
      this.thresholdGreater = false;
    }
  }

  modifyProcessCode(processCode, data) {
    if (data.trigger === 'Cyclic') {
      this.showTiming = true;
      this.hourValue = data.hour;
      this.secondsValue = data.seconds;
      this.dayOfMonthValue = data.dayOfMonth;
      this.dayOfWeekValue = data.dayOfWeek;
      this.minuteValue = data.minute;
      this.monthOfYearValue = data.monthOfYear;
    }
    this.modifyClicked = true
    this.changeButton = false;
    this.saveButton = false;
    this.showLocationHistory = false;
    // if (data.status == 'pending') {
    //   this.processCodeForm.disable();
    //   this.changeLocationEnable = false;

    // }
    if (data.status == 'approved') {
      this.processCodeForm.enable();
      this.processCodeForm.controls.partIdetifier.disable();
      this.processCodeForm.controls.cardId.disable();
      this.processCodeForm.controls.partNumber.disable();
      this.processCodeForm.controls.lineNumber.disable();
      this.processCodeForm.controls.transactionCode.disable();
      this.processCodeForm.controls.updateDate.disable();
      this.processCodeForm.controls.partName.disable();
      this.changeLocationEnable = true;
      this.saveButton = true;
    }

    this.modalRef = this.modalService.open(processCode, { size: 'lg', windowClass: 'detail-modal', backdrop: false });
    this.modalRef.result.then((result) => {
    });
    let ProcessNameValue = data.location.slice(2, 5);
    // let groupValues = data.location.slice(0,1);
    let processValue = ProcessNameValue.slice(0, 1);
    let processValueCode = ProcessNameValue.slice(1)
    let productCde = data.groupNo.slice(0, 1);
    let groupVal = data.groupNo.slice(1);
    this.processCodeForm.patchValue({
      cardId: data.cardId,
      deliveryPlant: data.deliveryPlant,
      partNumber: data.partNumber,
      partName: data.partName,
      lineNumber: data.lineNumber,
      storeQty: data.storeQuantity,
      transactionCode: "T",
      productionGrp: data.productionGroup,
      partIdetifier: data.partIdentifier,
      lotSeperate: data.lotSeperate,
      updateDate: this.dateFormatPipeFilter.transform(data.updatedDate),
      buildingNumber: data.buildingNo,
      group: groupVal,
      productCode: productCde,
      rackNumber: data.rackNo,
      validFrom: data.fromDate,
      validTo: data.toDate,
      processCde: processValue,
      processNo: processValueCode,
      level: data.level,
      column: data.column,
      shelfCapacity: data.shelfCapacity,
      replenishmentThreshold: data.replenishmentThreshold,
      transportationMode: data.transportationMode,
      trigger: data.trigger,

    });
    this.shelfCap = data.shelfCapacity;
    this.ReplenThresh = data.replenishmentThreshold;
    this.boxPerPal=data.boxesPerPallet;
    this.prodGroupValue(data.deliveryPlant);
    
  }
  copyProcessCode(processCode, data) {
    this.modifyClicked = false;
    this.changeLocationEnable = false;
    this.changeButton = true;
    this.saveButton = true;
    this.processCodeForm.enable();
    this.processCodeForm.controls.cardId.disable();
    this.processCodeForm.controls.partNumber.disable();
    this.processCodeForm.controls.lineNumber.disable();
    this.processCodeForm.controls.transactionCode.disable();
    this.processCodeForm.controls.updateDate.disable();
    this.processCodeForm.controls.partName.disable();
    this.modalRef = this.modalService.open(processCode, { size: 'lg', windowClass: 'detail-modal', backdrop: false });
    this.modalRef.result.then((result) => {
    });
    let ProcessNameValue = data.location.slice(2, 5);
    let processValue = ProcessNameValue.slice(0, 1);
    let processValueCode = ProcessNameValue.slice(1)
    let productCde = data.groupNo.slice(0, 1);
    let groupVal = data.groupNo.slice(1);
    this.processCodeForm.patchValue({
      cardId: data.cardId,
      deliveryPlant: data.deliveryPlant,
      partNumber: data.partNumber,
      partName: data.partName,
      lineNumber: data.lineNumber,
      storeQty: data.storeQuantity,
      transactionCode: "S",
      productionGrp: data.productionGroup,
      partIdetifier: data.partIdentifier,
      lotSeperate: data.lotSeperate,
      updateDate: this.dateFormatPipeFilter.transform(data.updatedDate),
      buildingNumber: data.buildingNo,
      productCode: productCde,
      group: groupVal,
      rackNumber: data.rackNo,
      validFrom: data.fromDate,
      validTo: data.toDate,
      processCde: processValue,
      processNo: processValueCode,
      level: data.level,
      column: data.column,
      shelfCapacity: data.shelfCapacity,
      replenishmentThreshold: data.replenishmentThreshold,
      transportationMode: data.transportationMode,
      trigger: data.trigger,
      

    })
    this.shelfCap = data.shelfCapacity;
    this.ReplenThresh = data.replenishmentThreshold;
    this.boxPerPal = data.boxesPerPallet

    // let partIdentity = this.processCodeForm.get('partIdetifier').value;
    this.valuechange(data.partIdentifier);
    this.prodGroupValue(data.deliveryPlant);
  }

  addProcessCode(processCode, item) {

    //Reset Shelf capacity and Replenishment Threshold ngModel value
    this.shelfCap = '';
    this.ReplenThresh = '';
    this.boxPerPal='';

    this.modifyClicked = false;
    this.changeButton = false;
    this.saveButton = true;
    this.showLocationHistory = false;
    this.processCodeForm.enable();
    this.processCodeForm.reset();
    this.processCodeForm.controls.cardId.disable();
    this.processCodeForm.controls.partNumber.disable();
    this.processCodeForm.controls.lineNumber.disable();
    this.processCodeForm.controls.transactionCode.disable();
    this.processCodeForm.controls.updateDate.disable();
    this.processCodeForm.controls.partName.disable();
    this.modalRef = this.modalService.open(processCode, { size: 'lg', windowClass: 'detail-modal', backdrop: false });
    this.modalRef.result.then((result) => {
    });
    var delPoint1 = item.deliveryPoint;
    this.processCodeForm.patchValue({
      cardId: 'NV',
      partNumber: item.partNumber,
      lineNumber: item.lineNumber,
      transactionCode: "S",
      updateDate: this.dateFormatPipeFilter.transform(item.updatedDate),
      partIdetifier: '',
      partName: item.partName
    })
    let partValue = this.processCodeForm.get('partIdetifier').value;
    this.valuechange(partValue);
    // if(this.identifierData){
    //   this.processCodeForm.controls.partIdetifier.disable();
    // }
  }

  omit_special_char(event) {
    let k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32 || (k >= 48 && k <= 57));
  }

  valuechange(newValue) {

    var partIdf;

    if (newValue == undefined || newValue == null || newValue == '') {
      if (this.processCodedata) {
        if (this.processCodedata.length > 0) {
          partIdf = '%20'; // Send part identifier with space, If one supply code created with space " " already
        } else {
          partIdf = ""; // Send part identifier without space, If no supply process code is created
        }
      }
    } else {
      partIdf = newValue.toUpperCase();
    }

    var id = this.processCodeForm.get('partNumber').value + '_' + this.processCodeForm.get('lineNumber').value + '_' + partIdf;
    if (newValue.length > 0 || newValue != null) {
      this.logbaseService.getPartIdentifier(id).subscribe(
        result => {
          this.data = result;
          this.identifierData = this.data.response
          // set success message and pass true paramater to persist the message after redirecting to the login page
          if (this.identifierData == false) {
            document.getElementById("mytext").innerHTML = "";
            this.saveButton = true;
            this.processCodeForm.controls.partIdetifier.disable();
          }
          else if (this.identifierData == true) {
            document.getElementById("mytext").innerHTML = "Part Identifier Already Taken";
            this.saveButton = false;
          }
        },
        error => {
          this.postFormError();
        });;
    }
    else {
      // this.userIDTaken = false;
      document.getElementById("mytext").innerHTML = " ";
    }

  }

  postFormError() {
    this.toaster.warning('Problem while Submission, Kindly check your network status');
  }

  submitProcessCode(f) {
    if (this.processCodeForm.get('partIdetifier').value == '' || this.processCodeForm.get('partIdetifier').value == ' '
      || this.processCodeForm.get('partIdetifier').value || this.processCodeForm.get('partIdetifier').value != null || this.processCodeForm.get('partIdetifier').value != undefined) {
      if (this.processCodeForm.valid) {

        // TO send empty space in part identifier for the first time to follow process code format

        var PID = this.processCodeForm.get('partIdetifier').value;

        if (PID == null || PID == '') {
          PID = " "; // One Space in the value
        } else {
          PID = this.processCodeForm.get('partIdetifier').value.toUpperCase();
        }

        let processName = this.processCodeForm.get('processCde').value + this.processCodeForm.get('processNo').value;
        let groupValue = this.processCodeForm.get('productCode').value + this.processCodeForm.get('group').value;
        let supplyProcessCode = this.processCodeForm.get('productCode').value + this.processCodeForm.get('group').value + processName + this.processCodeForm.get('rackNumber').value + this.processCodeForm.get('level').value;
        var id = this.processCodeForm.get('partNumber').value + '_' + this.processCodeForm.get('lineNumber').value + '_' + PID.toUpperCase();
        var dataToSend = {
          id: id,
          cardId: this.processCodeForm.get('cardId').value,
          deliveryPlant: this.processCodeForm.get('deliveryPlant').value,
          productionGroup: this.processCodeForm.get('productionGrp').value,
          partNumber: this.processCodeForm.get('partNumber').value,
          partName: this.processCodeForm.get('partName').value,
          partIdentifier: PID,
          lineNumber: this.processCodeForm.get('lineNumber').value,
          action: null,
          status: 'approved',
          deliveryPoint: this.dataDeliveryPt,
          storeQuantity: this.processCodeForm.get('storeQty').value,
          transCode: this.processCodeForm.get('transactionCode').value,
          lotSeperate: this.processCodeForm.get('lotSeperate').value,
          buildingNo: this.processCodeForm.get('buildingNumber').value,
          groupNo: groupValue,
          processName: processName,
          rackNo: this.processCodeForm.get('rackNumber').value,
          level: this.processCodeForm.get('level').value,
          isDeleted: 'false',
          createBy: this.loginId,
          updatedBy: this.loginId,
          fromDate: this.processCodeForm.get('validFrom').value,
          toDate: this.processCodeForm.get('validTo').value,
          location: supplyProcessCode,
          shelfCapacity: this.processCodeForm.get('shelfCapacity').value,
          replenishmentThreshold: this.processCodeForm.get('replenishmentThreshold').value,
          column: this.processCodeForm.get('column').value,
          boxesPerPallet: this.processCodeForm.get('boxperpallet').value,
          historyList: [{
            // status: "pending",
            status: "approved",
            supplierprocesscode: supplyProcessCode,
            roleName: this.roleName,
            comments: null,
            buildingNo: this.processCodeForm.get('buildingNumber').value,
            groupNo: groupValue,
            processName: processName,
            shelfCapacity: this.processCodeForm.get('shelfCapacity').value,
            replenishmentThreshold: this.processCodeForm.get('replenishmentThreshold').value,
            column: this.processCodeForm.get('column').value,
            rackNo: this.processCodeForm.get('rackNumber').value,
            level: this.processCodeForm.get('level').value,
            fromDate: this.processCodeForm.get('validFrom').value,
            toDate: this.processCodeForm.get('validTo').value,
            updatedBy: this.loginId,
          }],
          transportationMode: this.processCodeForm.get('transportationMode').value,
          trigger: this.processCodeForm.get('trigger').value,
          seconds: this.processCodeForm.get('seconds').value,
          minute: this.processCodeForm.get('minute').value,
          hour: this.processCodeForm.get('hour').value,
          dayOfMonth: this.processCodeForm.get('dayOfMonth').value,
          monthOfYear: this.processCodeForm.get('monthOfYear').value,
          dayOfWeek: this.processCodeForm.get('dayOfWeek').value,

        }
        var partNumber = this.processCodeForm.get('partNumber').value;
        this.logbaseService.saveProcessCode(dataToSend).subscribe(
          result => {

            // To remove value created previously
         //   this.shelfCap = '';
           // this.ReplenThresh = '';

            if (this.modifyClicked == true) {
              this.changeLocation();
              this.spinner.hide();
              this.toaster.success(this.translate.instant('Supply Process Code added successfully'));
              this.closeModal();
            }
            else if (this.modifyClicked == false) {
              this.modalRef.close();
              this.spinner.hide();
              this.toaster.success(this.translate.instant('Supply Process Code added successfully'));
              this.showLocationHistory = false;
              this.rerender(partNumber);
              f.reset();
              this.closeModal();
            }

          })
      }
      else {
        this.toaster.warning(this.translate.instant('Please Fill Form to submit'));
        this.spinner.hide();
      }
    }
    else if (this.processCodeForm.get('partIdetifier').value == null || this.processCodeForm.get('partIdetifier').value == undefined) {
      this.spinner.hide();
      this.toaster.warning(this.translate.instant('Please fill Part identifier to submit'));
    }
  }



  changeLocation() {
    this.showLocationHistory = true;
    let locationData = {
      lineNumbers: this.lineNumbers,
      partNumber: this.processCodeForm.get('partNumber').value,
      roleId: this.userRoleID
    }
    this.sub = this.logbaseService.searchProcessCode(locationData).subscribe(
      result => {
        this.locationHistory = result;
        this.historyData = this.locationHistory.response;
        this.historyData.forEach(e => {
          if (e.partIdentifier == this.processCodeForm.controls.partIdetifier.value) {
            this.historyListData = e.historyList;
            this.historyListData.forEach(element => {
              this.historyValue = element.processName;
              element['processValCode'] = this.historyValue.slice(0, 1);
              element['processValName'] = this.historyValue.slice(1);
              this.historyGroup = element.groupNo;
              element['productCode'] = this.historyGroup.slice(0, 1);
              element['group'] = this.historyGroup.slice(1)
            });
          }
        })
        if (this.showLocationHistory == true) {
          // this.history_dtTrigger.next();
        }
      });

    // this.processCodeForm.controls.buildingNumber.reset();
    // this.processCodeForm.controls.group.reset();
    // this.processCodeForm.controls.processCde.reset();
    // this.processCodeForm.controls.processNo.reset();
    // this.processCodeForm.controls.validFrom.reset();
    // this.processCodeForm.controls.validTo.reset();
  }

  // ngOnDestroy(): void {
  //   this.partList_dtTrigger.unsubscribe();
  //   this.processList_dtTrigger.unsubscribe();
  //   this.history_dtTrigger.unsubscribe();
  // };
  rerender(parts) {
    this.spinner.show();
    // this.dtElements.forEach((dtElement: DataTableDirective, index: number) => {
    //   dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
    //     // Destroy the table first
    //     dtInstance.destroy();
    //   });
    // });
    this.logbaseService.checkDeliveryPoint(this.deliveryPoint).subscribe(
      result => {
        this.plantName = result.response.plantName;
        this.spinner.hide();
        // this.partList_dtTrigger.next();
      })
    let dataToSend = {
      lineNumbers: this.lineNumbers,
      partNumber: parts,
      roleId: this.userRoleID
    }
    this.logbaseService.searchProcessCode(dataToSend).subscribe(
      result => {
        this.processCodeList = result;
        this.processCodedata = this.processCodeList.response;
        this.spinner.hide();
        // this.processList_dtTrigger.next();
      })
  }

  closeModal() {
    this.showTiming = false;
    this.processCodeForm.reset();
    this.modalRef.close();
    this.showLocationHistory = false;
    this.searchParts();
  }

  upload(file) {
  }

  exportCSV() {
    let exportData = this.processCodedata;
    let newExportData = [];
    exportData.forEach(x => {
      let obj = {}
      obj['partNumber'] = x.partNumber,
        obj['partName'] = x.partName,
        obj['lineNumber'] = x.lineNumber,
        obj['partIdentifier'] = x.partIdentifier,
        obj['deliveryPoint'] = x.deliveryPoint,
        obj['location'] = x.location,
        obj['boxesPerPallet'] = x.boxesPerPallet
      newExportData.push(obj)
    });
    var options = {
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalseparator: '.',
      showLabels: true,
      showTitle: false,
      headers: ['Part Number', 'Part Name', 'Next Process', 'Part Identifier', 'Delivery Point', 'Supply Process Code', 'BoxesPerPallet']
    };
    new AngularCsv(newExportData, 'Supply Process Code', options);
  };

  downloadTemplate() {
    var sampleTempleURL = 'https://a9ndevjpeastlbs01.blob.core.windows.net/assembly-op-upload-template/KKUpLoadSheet_Template.xlsx'+this.saas_token;
    window.open(sampleTempleURL, "_blank");
  };

  uploadSupplyProcessCode(event, form) {
    const formdata = new FormData();
    event.files.forEach(function (value, key) {
      formdata.append('imageFiles', value);
    });
  }

  onItemSelect(event){
    this.lineNoSrchInput.push(event);
  }
  onDeSelect(event){
    let lineNos:any[]=this.lineNoSrchInput;
    const index=lineNos.indexOf(event);
    this.lineNoSrchInput.splice(index, 1);
  }
}
